import store from "@/store/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Prijava",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
          next();
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Not found",
    component: () => import("../views/auth/errors/404-cover"),
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "Dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic"),
  },
  {
    path: "/auth/signin-basic",
    name: "signin-basic",
    meta: {
      title: "Signin Basic",
      authRequired: true,
    },
    component: () => import("../views/auth/signin/basic"),
  },
  {
    path: "/auth/signin-cover",
    name: "signin-cover",
    meta: {
      title: "Signin Cover",
      authRequired: true,
    },
    component: () => import("../views/auth/signin/cover"),
  },
  {
    path: "/auth/signup-basic",
    name: "signup-basic",
    meta: {
      title: "Signup Basic",
      authRequired: true,
    },
    component: () => import("../views/auth/signup/basic"),
  },
  {
    path: "/auth/signup-cover",
    name: "signup-cover",
    meta: {
      title: "Signup Cover",
      authRequired: true,
    },
    component: () => import("../views/auth/signup/cover"),
  },
  {
    path: "/auth/reset-pwd-basic",
    name: "reset-pwd-basic",
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
    component: () => import("../views/auth/reset/basic"),
  },
  {
    path: "/auth/reset-pwd-cover",
    name: "reset-pwd-cover",
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
    component: () => import("../views/auth/reset/cover"),
  },
  {
    path: "/auth/create-pwd-basic",
    name: "create-pwd-basic",
    meta: {
      title: "create Password",
      authRequired: true,
    },
    component: () => import("../views/auth/create/basic"),
  },
  {
    path: "/auth/create-pwd-cover",
    name: "create-pwd-cover",
    meta: {
      title: "create Password",
      authRequired: true,
    },
    component: () => import("../views/auth/create/cover"),
  },
  {
    path: "/auth/lockscreen-basic",
    name: "lock-screen-basic",
    meta: {
      title: "Lock Screen",
      authRequired: true,
    },
    component: () => import("../views/auth/lockscreen/basic"),
  },
  {
    path: "/auth/lockscreen-cover",
    name: "lock-screen-cover",
    meta: {
      title: "Lock Screen",
      authRequired: true,
    },
    component: () => import("../views/auth/lockscreen/cover"),
  },
  {
    path: "/auth/twostep-basic",
    name: "twostep-basic",
    meta: {
      title: "Two Step Auth",
      authRequired: true,
    },
    component: () => import("../views/auth/twostep/basic"),
  },
  {
    path: "/auth/twostep-cover",
    name: "twostep-cover",
    meta: {
      title: "Two Step Auth",
      authRequired: true,
    },
    component: () => import("../views/auth/twostep/cover"),
  },
  {
    path: "/auth/404",
    name: "404",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404"),
  },
  {
    path: "/auth/500",
    name: "500",
    meta: {
      title: "Error 500",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/500"),
  },
  {
    path: "/auth/404-basic",
    name: "404-basic",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404-basic"),
  },
  {
    path: "/auth/404-cover",
    name: "404-cover",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404-cover"),
  },
  {
    path: "/auth/ofline",
    name: "ofline",
    meta: {
      title: "Offline",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/ofline"),
  },
  {
    path: "/auth/logout-basic",
    name: "logout-basic",
    meta: {
      title: "Logout",
      authRequired: true,
    },
    component: () => import("../views/auth/logout/basic"),
  },
  {
    path: "/auth/logout-cover",
    name: "logout-cover",
    meta: {
      title: "Logout",
      authRequired: true,
    },
    component: () => import("../views/auth/logout/cover"),
  },
  {
    path: "/auth/success-msg-basic",
    name: "success-msg-basic",
    meta: {
      title: "Success Message",
      authRequired: true,
    },
    component: () => import("../views/auth/success-msg/basic"),
  },
  {
    path: "/auth/success-msg-cover",
    name: "success-msg-cover",
    meta: {
      title: "Success Message",
      authRequired: true,
    },
    component: () => import("../views/auth/success-msg/cover"),
  },
  {
    path: "/requests",
    name: "Requests",
    meta: { title: "Zahtjevi", authRequired: true },
    component: () => import("../views/requests/index"),
  },
  {
    path: "/requests/details/:id",
    name: "PreviewRequest",
    meta: { title: "Pregled zahtjeva", authRequired: true },
    component: () => import("../views/requests/details"),
  },
  {
    path: "/associations",
    name: "Associations",
    meta: { title: "Udruge", authRequired: true },
    component: () => import("../views/associations/index"),
  },
  {
    path: "/extracts",
    name: "Extracts",
    meta: { title: "Izvadak", authRequired: true },
    component: () => import("../views/extracts/index"),
  },
  {
    path: "/associations/details/:id",
    name: "AssociationDetails",
    meta: { title: "Pregled udruge", authRequired: true },
    component: () => import("../views/associations/details"),
  },
  {
    path: "/associations/:id/update/:requestId",
    name: "UpdateAssociation",
    meta: { title: "Upis promjena", authRequired: true },
    component: () => import("../views/associations/update"),
  },
  {
    path: "/associations/:id/liquidate/:requestId/:requestInitiationTypeId",
    name: "LiquidateAssociation",
    meta: { title: "Likvidacija udruženja", authRequired: true },
    component: () => import("../views/associations/liquidate"),
  },
  {
    path: "/associations/:id/history/:historyId/edit",
    name: "EditAssociationHistory",
    meta: { title: "Uređivanje historije promjene", authRequired: true },
    component: () => import("../views/associations/history/edit"),
  },
  {
    path: "/associations/:id/history/:historyId/edit-liquidate",
    name: "EditAssociationHistoryLiquidate",
    meta: { title: "Uređivanje historije likvidacije", authRequired: true },
    component: () => import("../views/associations/history/edit-liquidate.vue"),
  },
  {
    path: "/associations/:id/history/:historyId/edit-first-entry",
    name: "EditAssociationInitialHistory",
    meta: { title: "Uređivanje prvog upisa", authRequired: true },
    component: () => import("../views/associations/history/edit-first-entry"),
  },
  {
    path: "/associations/:id/history/:historyId/preview",
    name: "PreviewAssociationHistory",
    meta: { title: "Pregled historije promjene", authRequired: true },
    component: () => import("../views/associations/history/preview"),
  },
  {
    path: "/associations/add/:requestId",
    name: "AddAssociation",
    meta: { title: "Nova udruga", authRequired: true },
    component: () => import("../views/associations/add"),
  },
  {
    path: "/administration/activities",
    name: "Activities",
    meta: { title: "Djelatnosti", authRequired: true },
    component: () => import("../views/administration/activities/index"),
  },
  {
    path: "/reports",
    name: "Reports",
    meta: {
      title: "Izvješća",
      authRequired: true,
    },
    component: () => import("../views/reports/index"),
  },
  {
    path: "/reports/mandate-expirations",
    name: "MandateExpiration",
    meta: {
      title: "Pregled isteka mandata",
      authRequired: true,
    },
    component: () => import("../views/reports/mandate-expirations/index"),
  },
  {
    path: "/reports/associations-activities",
    name: "AssociationsActivities",
    meta: {
      title: "Pregled djelatnosti udruženja",
      authRequired: true,
    },
    component: () => import("../views/reports/associations-activities/index"),
  },
  {
    path: "/reports/associations-history",
    name: "AssociationsHistory",
    meta: {
      title: "Pregled historije promjena",
      authRequired: true,
    },
    component: () => import("../views/reports/associations-history/index"),
  },
  {
    path: "/reports/requests-stats",
    name: "RequestsStats",
    meta: {
      title: "Pregled statistike",
      authRequired: true,
    },
    component: () => import("../views/reports/requests-stats/index"),
  },
  {
    path: "/reports/associations-history-detailed",
    name: "AssociationsHistoryDetailed",
    meta: {
      title: "Pregled detaljne historije udruženja",
      authRequired: true,
    },
    component: () => import("../views/reports/associations-history-detailed/index"),
  },
  {
    path: "/administration",
    name: "Administration",
    meta: {
      title: "Administracija",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/index"),
  },
  {
    path: "/employees",
    name: "Employees",
    meta: { title: "Djelatnik", authRequired: true },
    component: () => import("../views/employees/index"),
  },
  {
    path: "/about",
    name: "About",
    meta: { title: "O programu", authRequired: true },
    component: () => import("../views/about/index"),
  },
  {
    path: "/administration/countries",
    name: "Countries",
    meta: {
      title: "Države",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/countries/index"),
  },
  {
    path: "/administration/states",
    name: "States",
    meta: {
      title: "Entiteti",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/states/index"),
  },
  {
    path: "/administration/cantons",
    name: "Cantons",
    meta: {
      title: "Kantoni",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/cantons/index"),
  },
  {
    path: "/administration/functions",
    name: "Functions",
    meta: {
      title: "Funkcije",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/functions/index"),
  },
  {
    path: "/administration/municipalities",
    name: "Municipalities",
    meta: {
      title: "Opštine",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/municipalities/index"),
  },
  {
    path: "/administration/places",
    name: "Places",
    meta: {
      title: "Mjesta",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/places/index"),
  },
  {
    path: "/administration/users",
    name: "Users",
    meta: {
      title: "Korisnici",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/users/index"),
  },
  {
    path: "/administration/liquidation-reasons",
    name: "LiquidationReasons",
    meta: {
      title: "Razlozi prestanka rada",
      authRequired: true,
      permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"],
    },
    component: () => import("../views/administration/liquidation-reasons/index"),
  },

  {
  path: "/administration/reverted-changes-history",
  name: "revertedChangesHistory",
  meta: {
    title: "Historija poništenih promjena",
    authRequired: true, 
    permissions: ["Može pristupiti superadministratorskom dijelu aplikacije"] 
  },
  component: () => import("../views/administration/revertedChangesHistory/index.vue")
}
];
